/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Turns activeCellId into an object to be able to
// update cell coordinates more easily
export var getCellIdAsObject = function getCellIdAsObject(oldId) {
  var oldIdArr = oldId.split('-');
  var updatedOldValuesArray = oldIdArr.map(function (item) {
    if (isNaN(item)) {
      return item;
    }

    return Number(item);
  });
  var indexArray = updatedOldValuesArray.filter(Number.isFinite);
  var keyArray = updatedOldValuesArray.filter(function (item) {
    return typeof item === 'string';
  });
  var activeCellCoords = {};
  keyArray.forEach(function (element, index) {
    activeCellCoords[element] = indexArray[index];
  });
  return activeCellCoords;
};